import * as React from "react";
const SvgFiRrSquarePhoneHangup = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-square-phone-hangup_svg__a)">
      <path
        fill="#062147"
        d="M18.196 10.961c.49.49.805 1.159.804 1.906l-.053 1.038c0 .605-.49 1.095-1.095 1.095l-1.56-.205c-.605 0-1.095-.49-1.095-1.095l-.148-1.578c-1.939-.868-3.968-.91-6.099 0L8.802 13.7c0 .605-.49 1.095-1.095 1.095L6.147 15c-.605 0-1.095-.49-1.095-1.095l-.053-1.038c0-.747.314-1.416.804-1.906 2.711-2.711 9.874-2.517 12.391 0zM24 5v14c0 2.757-2.243 5-5 5H5c-2.757 0-5-2.243-5-5V5c0-2.757 2.243-5 5-5h14c2.757 0 5 2.243 5 5m-2 0c0-1.654-1.346-3-3-3H5C3.346 2 2 3.346 2 5v14c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-square-phone-hangup_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSquarePhoneHangup;
